import React from 'react';
import { graphql } from "gatsby";

import Layout from '../../components/layout.js';
import SEO from '../../components/seo.js';
import PageHeading from '../../components/page-heading.js';
import CaseStudyTile from '../../components/case-study-tile.js';
import articles, { withImages } from '../../data/articles.js';
import '../../styles/article.scss';

const Blog = ({data}) => {

    const items = withImages(articles, data);
    
    return (
        <Layout background="stone">
            <SEO title="Shopify Guides & Insights | 54 Bit Studios Blog" description="Articles, guides and case studies for Shopify and Shopify Plus brands, covering site speed, SEO, conversion rate optimisation, analytics and website budgets." />
            <PageHeading h1="The Blog" h2="" blurb="Discover our latest articles and insights for Shopify and Shopify Plus stores, including case studies, optimisation guides, and more..." />
            <section className='ff case-studies blog' id='case-studies'>
                <div className="grid">
                    {items.map(article => (
                        <CaseStudyTile
                            key={article.client}
                            image={article.image}
                            client={article.client}
                            blurb={article.blurb}
                            tags={article.tags}
                            link={article.link}
                            type={article.type}
                            year={article.year}
                        />
                    ))}
                </div>
            </section>
        </Layout>
    );
};

export default Blog;

export const query = graphql`
    query {
        allFile(filter: { sourceInstanceName: { eq: "assets" } }) {
            nodes {
                name
                relativePath
                childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, width: 1200)
                }
            }
        }
    }
`;